import React, { FC } from 'react'

type contentProps = {
  postData: any
}
const Mp4Page: FC<contentProps> = ({ postData }) => {
  return <div dangerouslySetInnerHTML={{ __html: postData }}></div>
}

export default Mp4Page
